enum BadgePos {
    Bottom = "bottom",
    Top = "top",
    Left = "left",
    Right = "right",
    Custom = "custom"
}

type PositionOptions = {
    customHorizontal: string;
    customVertical: string;
}

export const calculatePosition = (position: BadgePos, options?: any): string => {
    switch (position) {
        case BadgePos.Bottom:
            return "-bottom-4 left-1/2 -translate-x-1/2"
        case BadgePos.Top:
            return "-top-4 left-1/2 -translate-x-1/2"
        case BadgePos.Left:
            return "-left-4"
        case BadgePos.Right:
            return "-right-4"
        case BadgePos.Custom:
            return calculateCustomPosition(options)
        default:
            return ""
    }
}

enum customHorizontalPositions {
    Left = "left",
    Right = "right"
}

enum customVerticalPositions {
    Top = "top",
    Bottom = "bottom"
}

export const calculateCustomPosition = (options: PositionOptions): string => {
    let pos = "";
    switch (options.customVertical) {
        case customVerticalPositions.Top:
            switch (options.customHorizontal) {
                case customHorizontalPositions.Left:
                    pos = "-top-4 -left-4"
                    break;
                case customHorizontalPositions.Right:
                    pos = "-top-4 -right-4";
                    break;
            }
            break;
        case customVerticalPositions.Bottom:
            switch (options.customHorizontal) {
                case customHorizontalPositions.Left:
                    pos = "-bottom-4 -left-4";
                    break;
                case customHorizontalPositions.Right:
                    pos = "-bottom-4 -right-4";
                    break;
            }
            break;
    }
    return pos;
}
